import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    top: 'shadow-header text-main flex h-[52px] w-full gap-4 bg-white px-[14px] transition lg:h-[82px]',
    container: 'relative container flex h-full items-center justify-center',

    topLeftLink: [
      'absolute top-0 bottom-0 left-0 lg:left-7',
      'link flex items-center justify-start'
    ],
    linkArrow: 'size-[24px] rotate-90 lg:size-8',

    topLogo: 'flex-center',
    logoBrand: 'flex-center h-6 w-34 flex-1 text-gray-500'
  }
});
